import { Button } from '@insify/design-system/components';
import { textMd } from '@insify/design-system/typography';
import { formatMoney } from '@insify/global-money';
import { animated, useSpring } from '@react-spring/web';
import clsx from 'clsx';

import { Layout } from '../Layout';

import * as styles from './TotalPremium.module.css';

import type { CountryCode } from '@insify/global-countries';
import type { MoneyField } from '@insify/global-money';

type Props = {
  country: CountryCode | Lowercase<CountryCode>;
  hide: boolean;
  onClick: () => void;
  onBack: () => void;
  total?: MoneyField;
  isLoading?: boolean;
  content: {
    per_period: string;
    continue: string;
  };
};

export const TotalPremium = ({ country, hide, onClick, onBack, total, isLoading, content }: Props) => {
  const animatedPrice = useSpring({
    number: total?.cents || '1',
    from: { number: '0' },
    config: { friction: 22, mass: 1 },
  });

  return (
    <Layout.BottomBar className={clsx(styles.bottomBar, hide && styles.hidden)}>
      <div className={[styles.price, isLoading ? styles.loading : ''].join(' ')}>
        <animated.span className={styles.amount} data-testid='premium-bar-price'>
          {animatedPrice.number.to((price) =>
            formatMoney({ cents: price, currency: total?.currency || 'EUR' }, country),
          )}
        </animated.span>
        <div className={clsx(textMd, styles.perMonth)}>{content.per_period}</div>
      </div>
      <Layout.MobileOnly>
        <Layout.BackSmall backCopy={''} onBack={onBack} />
      </Layout.MobileOnly>
      <Button
        onClick={onClick}
        trackingId='continue'
        type='submit'
        kind='primary'
        loading={isLoading}
        className={styles.button}
      >
        {content.continue}
      </Button>
    </Layout.BottomBar>
  );
};
